import firebase from 'firebase'
import firestore from "firebase/firestore";

var config = { /* COPY THE ACTUAL CONFIG FROM FIREBASE CONSOLE */
  apiKey: "AIzaSyC8gjL2ONiCXK7AMTOSDH3nfnFsRSV9WyQ",
  authDomain: "thankfully-app.firebaseapp.com",
  storageBucket: "thankfully-app.appspot.com",
  projectId: "thankfully-app"
};
var fire = firebase.initializeApp(config);
export default fire;



// WEBPACK FOOTER //
// ./src/fire.js